export const getPerimeters = (state) => state.perimeters
export const getMainPerimeters = (state) => state.main_perimeters
export const getUserAssignRight = (state) => state.user_right
export const getUserAssignDoorSonote = (state) => state.user_assign